import { createContext, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const PreviousPathContext = createContext<string | null>(null);

export const PreviousPathProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const location = useLocation();
  const prevPathRef = useRef<string | null>(null);

  useEffect(() => {
    prevPathRef.current = location.pathname;
  }, [location]);

  return (
    <PreviousPathContext.Provider value={prevPathRef.current}>
      {children}
    </PreviousPathContext.Provider>
  );
};
